import app from 'flarum/forum/app';
import {extend, override} from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Button from "flarum/common/components/Button";
import CustomSignUpModal from "./components/CustomSignUpModal/CustomSignUpModal";
import ModalManagerState from "flarum/common/states/ModalManagerState";
import SignUpModal from "flarum/forum/components/SignUpModal";


app.initializers.add('prokrasivoe/custom-register', () => {
  console.log("Custom Register Plugin Loaded!");

  override(SignUpModal.prototype, 'view', function () {
    return (<CustomSignUpModal/>);
  });
});
